import { render, staticRenderFns } from "./Surface.vue?vue&type=template&id=0f9a6dc4&"
import script from "./Surface.vue?vue&type=script&lang=js&"
export * from "./Surface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports